/******/ (() => { // webpackBootstrap
var __webpack_exports__ = {};

// ===== Protection Fee Logic =====
// const PROTECTION_VARIANT_ID = 50924113592567; // <-- REPLACE with your dedicated "Shipping Protection" product's variant ID
// const MIN_QTY = 1;
// const MAX_QTY = 99;
// const FEE_RATE = 0.02;           // 2%

// function getProtectionItem(cart) {
//   return cart.items.find(item => item.variant_id === PROTECTION_VARIANT_ID);
// }

// // Sends cart mutations with an explicit JSON body and a real Number for
// // quantity — not jQuery's default form-encoding. Some cart/discount apps
// // on this store hook into cart AJAX calls and can re-serialize the
// // request, which was turning our quantity into a string and causing
// // Shopify to reject it ("expected String to be a Integer: quantity").
// // Being explicit here removes that ambiguity.
// function postCartJson(url, data) {
//   if (typeof data.quantity !== 'undefined') {
//     data.quantity = Number(data.quantity);
//   }
//   return $.ajax({
//     url: url,
//     type: 'POST',
//     contentType: 'application/json',
//     dataType: 'json',
//     data: JSON.stringify(data)
//   });
// }

// // ===== Cart operation queue =====
// // Multiple things can try to modify the cart around the same moment (the
// // automatic stale-item cleanup on drawer open, a quick click on "Protected
// // Checkout," a quantity change, etc). Firing two cart-mutating requests at
// // once can cause one of them to fail. This queue forces every cart
// // mutation through here so they always run one after another, never
// // overlapping — eliminating that race instead of just hoping it doesn't happen.
// let cartOpQueue = $.Deferred().resolve().promise();
// function enqueueCartOp(fn) {
//   const result = cartOpQueue.then(fn, fn);
//   cartOpQueue = result.then(function () {}, function () {});
//   return result;
// }

// // ⚠️ CURRENCY-SAFE FEE APPLICATION
// // Nothing here is hardcoded in dollars/rupees/etc. The min and max fee are
// // derived from the LIVE product price (read fresh from the cart API, in
// // whatever currency is currently active) multiplied by the allowed
// // quantity range (1–99). That way if currency changes, or you swap to a
// // different protection product later, this keeps working with zero edits.
// function applyProtectionFeeAndProceed(onDone, onError) {
//   enqueueCartOp(function () {
//     return $.getJSON('/cart.js').then(function (cart) {
//       const existing = getProtectionItem(cart);
//       const baseTotalCents = cart.total_price - (existing ? existing.line_price : 0);

//       const ensureOneUnit = existing
//         ? $.Deferred().resolve(existing).promise()
//         : postCartJson('/cart/add.js', {
//             id: PROTECTION_VARIANT_ID,
//             quantity: 1,
//             properties: { '_protection': 'true' }
//           });

//       return ensureOneUnit.then(function (item) {
//         const unitPriceCents = item.price; // REAL price, current currency, read live

//         const minFeeCents = unitPriceCents * MIN_QTY;
//         const maxFeeCents = unitPriceCents * MAX_QTY;

//         let feeCents = Math.round(baseTotalCents * FEE_RATE);
//         feeCents = Math.min(Math.max(feeCents, minFeeCents), maxFeeCents);

//         const targetQty = Math.min(MAX_QTY, Math.max(MIN_QTY, Math.ceil(feeCents / unitPriceCents)));

//         return postCartJson('/cart/change.js', { id: item.key, quantity: targetQty });
//       }, function (xhr) {
//         console.error('[Protection Fee] Failed to add initial unit:', xhr.responseText);
//         throw xhr;
//       });
//     }, function (xhr) {
//       console.error('[Protection Fee] Failed to read cart.js:', xhr.responseText);
//       throw xhr;
//     });
//   }).done(function () {
//     onDone();
//   }).fail(function (xhr) {
//     console.error('[Protection Fee] Failed to set final quantity:', xhr && xhr.responseText);
//     if (onError) onError(xhr);
//   });
// }

// // Removes any leftover protection line item that might still be sitting in
// // the cart (e.g. customer clicked "Protected Checkout", then hit back
// // instead of completing checkout). Keeps the drawer's subtotal honest.
// function removeStaleProtectionItem(callback) {
//   enqueueCartOp(function () {
//     return $.getJSON('/cart.js').then(function (cart) {
//       const protectionItem = getProtectionItem(cart);
//       if (protectionItem && protectionItem.quantity > 0) {
//         return postCartJson('/cart/change.js', { id: protectionItem.key, quantity: 0 }).then(
//           function () { return true; },
//           function (xhr) {
//             console.error('[Protection Fee] Failed to clean up stale item:', xhr.responseText);
//             return false;
//           }
//         );
//       }
//       return false;
//     }, function (xhr) {
//       console.error('[Protection Fee] Failed to read cart.js during cleanup:', xhr.responseText);
//       return false;
//     });
//   }).done(function (removed) {
//     if (callback) callback(removed);
//   }).fail(function () {
//     if (callback) callback(false);
//   });
// }

// // Enables/disables both checkout buttons based on whether the TOS checkbox
// // is checked (only relevant if the checkbox is actually rendered).
// function syncProtectionButtonsDisabledState() {
//   const $tos = $('.tos_agree');
//   const tosRequired = $tos.length > 0;
//   const isChecked = tosRequired ? $tos.is(':checked') : true;

//   $('[data-protected-checkout], [data-checkout-no-protection]')
//     .prop('disabled', !isChecked)
//     .toggleClass('disabled', !isChecked);
// }
// ===== End Protection Fee Logic =====

Shopify.theme.jsAjaxCart = {
  init: function ($section) {

    // Add settings from schema to current object
    Shopify.theme.jsAjaxCart = $.extend(this, Shopify.theme.getSectionData($section));

    if (isScreenSizeLarge() || this.cart_action == 'drawer') {
      this.initializeAjaxCart();
    } else {
      this.initializeAjaxCartOnMobile();
    }

    if (this.cart_action == 'drawer') {

      this.ajaxCartDrawer = $('[data-ajax-cart-drawer]');

      $(document).on('click', '[data-ajax-cart-trigger]', function (e) {
        e.preventDefault();
        Shopify.theme.jsAjaxCart.showDrawer();

        return false;
      });

    } else if (this.cart_action == 'mini_cart') {
      this.showMiniCartOnHover();
    }

    $(document).on('click', '.ajax-submit', function (e) {
      e.preventDefault();
      const $addToCartForm = $(this).closest('form');
      Shopify.theme.jsAjaxCart.addToCart($addToCartForm);

      return false;
    });

    $(document).on('click', '[data-ajax-cart-delete]', function (e) {
      e.preventDefault();
      const lineID = $(this).parents('[data-line-item]').data('line-item');
      Shopify.theme.jsAjaxCart.removeFromCart(lineID);

      if (Shopify.theme.jsCart) {
        Shopify.theme.jsCart.removeFromCart(lineID);
      }

      return false;
    });

    $(document).on('click', '[data-ajax-cart-close]', function (e) {
      e.preventDefault();
      Shopify.theme.jsAjaxCart.hideDrawer();
      Shopify.theme.jsAjaxCart.hideMiniCart();

      return false;
    });

    // ===== TOS checkbox enables/disables both checkout buttons =====
    $(document).on('click change', '.tos_agree', function () {
      // syncProtectionButtonsDisabledState();
    });

    // ===== "Protected Checkout | ₹X" button =====
    $(document).on('click', '[data-protected-checkout]', function (e) {
      e.preventDefault();

      const $btn = $(this);
      if ($btn.is(':disabled') || $btn.hasClass('disabled')) {
        return false;
      }

      $btn.prop('disabled', true).addClass('disabled');

      applyProtectionFeeAndProceed(
        function () {
          window.location.href = '/checkout';
        },
        function () {
          $btn.prop('disabled', false).removeClass('disabled');
          alert('Sorry, something went wrong adding shipping protection. Please try again.');
        }
      );

      return false;
    });

    // ===== "Checkout without protection" button =====
    $(document).on('click', '[data-checkout-no-protection]', function (e) {
      e.preventDefault();

      const $btn = $(this);
      if ($btn.is(':disabled') || $btn.hasClass('disabled')) {
        return false;
      }

      $btn.prop('disabled', true).addClass('disabled');

      // removeStaleProtectionItem(function () {
      //   window.location.href = '/checkout';
      // });

      return false;
    });

  },
  showMiniCartOnHover: function () {
    const $el = $('[data-ajax-cart-trigger]');

    $el.hover(function() {
      if(Shopify.theme_settings.header_layout == 'centered' && $('.header-sticky-wrapper').hasClass('is-sticky')) {
        $('.header-sticky-wrapper [data-ajax-cart-trigger]').addClass('show-mini-cart');
      } else {
        $el.addClass('show-mini-cart');
      }
    }, function() {
      $el.removeClass('show-mini-cart');
    });
  },
  hideMiniCart: function () {
    if (this.cart_action != 'mini_cart') return false;
    const $el = $('[data-ajax-cart-close]').parents('[data-ajax-cart-trigger]');
    $el.removeClass('show-mini-cart');
  },
  toggleMiniCart: function() {
    const $el = $('.mobile-header [data-ajax-cart-trigger]');

    // Removes url to the cart page so user is not redirected
    $el.attr('href', '#');

    $el.off('touchstart').on('touchstart', function (e) {
      // If user clicks inside the element, do nothing
      if (e.target.closest('[data-ajax-cart-mini_cart]')) {
        return;
      }

      // Loads content into ajaxCart container for mobile header
      Shopify.theme.jsAjaxCart.initializeAjaxCartOnMobile();

      // If user clicks outside the element, toggle the mini cart
      $el.toggleClass('show-mini-cart');
    });
  },
  showDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    if (
        window.wiserHandle?.cartAction &&
        typeof wiserHandle.cartAction === "function"
      ) {
        window.wiserHandle.cartAction();
      }else{
    this.ajaxCartDrawer.addClass('is-visible');
    $('.ajax-cart__overlay').addClass('is-visible');
    $('html').css('overflow','hidden');
      }
  },
  hideDrawer: function () {
    if (this.cart_action != 'drawer') return false;
    this.ajaxCartDrawer.removeClass('is-visible');
    $('.ajax-cart__overlay').removeClass('is-visible');
    $('html').css('overflow','auto');
  },
  removeFromCart: function (lineID, callback) {
    $.ajax({
      type: 'POST',
      url: '/cart/change.js',
      data: 'quantity=0&line=' + lineID,
      dataType: 'json',
      success: function (cart) {
        Shopify.theme.jsAjaxCart.updateView();
      },
      error: function (XMLHttpRequest, textStatus) {
        var response = eval('(' + XMLHttpRequest.responseText + ')');
        response = response.description;

      }
    });
  },
  initializeAjaxCart: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('[data-ajax-cart-content]').html(html.content);

        // Converting the currencies
        if (Shopify.theme.currencyConverter) {
          Shopify.theme.currencyConverter.convertCurrencies();
        }

        // syncProtectionButtonsDisabledState();

        // Clean up any leftover protection item from a previous, abandoned
        // checkout attempt so the subtotal shown here is always accurate.
        // removeStaleProtectionItem(function (removed) {
        //   if (removed) {
        //     Shopify.theme.jsAjaxCart.updateView();
        //   }
        // });

      })
      .fail(() => {
        // some error handling
      });
  },
  initializeAjaxCartOnMobile: function () {

    this.toggleMiniCart();

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
      .done(({ html, options }) => {

        $('.mobile-header [data-ajax-cart-content]').html(html.content);

        // syncProtectionButtonsDisabledState();

        // removeStaleProtectionItem(function (removed) {
        //   if (removed) {
        //     Shopify.theme.jsAjaxCart.updateView();
        //   }
        // });

      })
      .fail(() => {
        // some error handling
      });
  },
  addToCart: function ($addToCartForm) {
    const $addToCartBtn = $addToCartForm.find('.button--add-to-cart');

    $addToCartForm.removeClass('shopify-product-form--unselected-error');

    if ($addToCartBtn[0].hasAttribute('data-options-unselected')) {
      const cartWarning = `<p class="cart-warning__message animated bounceIn">${Shopify.translation.select_variant}</p>`;

      $('.warning').remove();

      $addToCartForm
        .addClass('shopify-product-form--unselected-error')
        .find('.cart-warning')
        .html(cartWarning);

      $addToCartBtn
        .removeAttr('disabled')
        .removeClass('disabled');

      $addToCartBtn.find('.icon')
        .removeClass('zoomOut')
        .addClass('zoomIn');

      $addToCartBtn
        .find('span:not(.icon)')
        .text($addToCartBtn.data('label'))
        .removeClass('zoomOut')
        .addClass('zoomIn');
    } else {
      $.ajax({
        url: '/cart/add.js',
        dataType: 'json',
        cache: false,
        type: 'post',
        data: $addToCartForm.serialize(),
        beforeSend: function () {
          $addToCartBtn
            .attr('disabled', 'disabled')
            .addClass('disabled');

          $addToCartBtn.find('span')
            .removeClass("fadeInDown")
            .addClass('animated zoomOut');
        },
        success: function (product) {

          let $el = $('[data-ajax-cart-trigger]');

          $addToCartBtn
            .find('.checkmark')
            .addClass('checkmark-active');

          function addedToCart() {

            if (!isScreenSizeLarge()) {
              $el = $('.mobile-header [data-ajax-cart-trigger]');
              Shopify.theme.scrollToTop($el);
            } else {
              $el = $('[data-ajax-cart-trigger]');
            }

            $el.addClass('show-mini-cart');

            $addToCartBtn.find('span')
              .removeClass('fadeInDown');
          }

          window.setTimeout(function () {
            $addToCartBtn
              .removeAttr('disabled')
              .removeClass('disabled');

            $addToCartBtn.find('.checkmark')
              .removeClass('checkmark-active');

            $addToCartBtn.find('.text, .icon')
              .removeClass('zoomOut')
              .addClass('fadeInDown');

            $addToCartBtn.on('webkitAnimationEnd oanimationend msAnimationEnd animationend', addedToCart);

          }, 1000);

          Shopify.theme.jsAjaxCart.showDrawer();
          Shopify.theme.jsAjaxCart.updateView();

          if (Shopify.theme.jsCart) {
            $.ajax({
              dataType: "json",
              async: false,
              cache: false,
              dataType: 'html',
              url: "/cart",
              success: function (html) {
                const cartForm = $(html).find('.cart__form');
                $('.cart__form').replaceWith(cartForm);

              }
            });
          }

        },
        error: function (XMLHttpRequest) {
          let response = eval('(' + XMLHttpRequest.responseText + ')');
          response = response.description;

          const cartWarning = `<p class="cart-warning__message animated bounceIn">${response.replace('All 1 ', 'All ')}</p>`;

          $('.warning').remove();

          $addToCartForm
            .find('.cart-warning')
            .html(cartWarning);

          $addToCartBtn
            .removeAttr('disabled')
            .removeClass('disabled');

          $addToCartBtn.find('.icon')
            .removeClass('zoomOut')
            .addClass('zoomIn');

          $addToCartBtn
            .find('span:not(.icon)')
            .text($addToCartBtn.data('label'))
            .removeClass('zoomOut')
            .addClass('zoomIn');
        }
      });
    }
  },
  updateView: function () {

    Shopify.theme.asyncView.load(
      Shopify.routes.cart_url, // template name
      'ajax', // view name (suffix)
    )
    .done(({ html, options }) => {

      if (options.item_count > 0) {
        const $newHtml = $(html.content);
        const itemList = $newHtml.find('.ajax-cart__list');
        const newSubtotal = $newHtml.find('.ajax-cart__subtotal');
        const newSavings = $newHtml.find('.ajax-cart__savings');
        const newProtectionInfo = $newHtml.find('.ajax-cart__protection-info');
        const newButtonWrapper = $newHtml.find('.ajax-cart__button-wrapper');
        const total_price = options.total_price

        $('.ajax-cart__list').replaceWith(itemList);

        // Surgically update only the pieces that change — NOT the whole
        // details-wrapper — so the TOS checkbox's checked state survives.
        if (newSubtotal.length) {
          $('.ajax-cart__subtotal').replaceWith(newSubtotal);
        }
        if (newSavings.length) {
          if ($('.ajax-cart__savings').length) {
            $('.ajax-cart__savings').replaceWith(newSavings);
          } else {
            $('.ajax-cart__subtotal').after(newSavings);
          }
        } else {
          $('.ajax-cart__savings').remove();
        }
        if (newProtectionInfo.length) {
          $('.ajax-cart__protection-info').replaceWith(newProtectionInfo);
        }
        if (newButtonWrapper.length) {
          $('.ajax-cart__button-wrapper').replaceWith(newButtonWrapper);
        }

        $('.ajax-cart__empty-cart-message').addClass('is-hidden');
        $('.ajax-cart__form').removeClass('is-hidden');
        $('[data-ajax-cart-trigger]').addClass('has-cart-count');
        $('[data-bind="itemCount"]').text(options.item_count);

        // The button-wrapper was just replaced with fresh server markup,
        // which always renders the buttons as disabled by default — re-sync
        // with the (untouched) checkbox's actual checked state.
        // syncProtectionButtonsDisabledState();

        /* Update shipping indicator asynchronously js */
        if($('[data-fs-threshold]').length){
          let $parent = $('[data-fs-threshold]')
          let $remainingWrapper = $parent.find('.fs-indicator__remaining')
          let $successWrapper = $parent.find('.fs-indicator__success')

          let fs_threshold = $('[data-fs-threshold]').data('fs-threshold');
          if(fs_threshold >= total_price){
            //udpate
            let fs_remaining = fs_threshold - total_price;
            let fs_remaining_percent = total_price / fs_threshold * 100

            $remainingWrapper.find('.bar').css('width', fs_remaining_percent + '%')
            $remainingWrapper.find('[data-bind="remaining-amount"]').text(Shopify.formatMoney(fs_remaining))

            $remainingWrapper.removeClass('is-hidden')
            $successWrapper.addClass('is-hidden')
          }else{
            //remove shipping indicator
            $remainingWrapper.addClass('is-hidden')
            $successWrapper.removeClass('is-hidden')
          }
        }

      } else {
        $('.ajax-cart__empty-cart-message').removeClass('is-hidden');
        $('.ajax-cart__form').addClass('is-hidden');
        $('[data-ajax-cart-trigger]').removeClass('has-cart-count');
        $('[data-bind="itemCount"]').text('0');
      }

      if (Shopify.theme.currencyConverter) {
        Shopify.theme.currencyConverter.convertCurrencies();
      }
    })
    .fail(() => {
      // some error handling
    });
  },
  unload: function ($section) {

    // Clear event listeners in theme editor
    $('.ajax-submit').off();
    $('[data-ajax-cart-delete]').off();
  }
}

/******/ })()
;